import { render, staticRenderFns } from "./AssembleiaList.vue?vue&type=template&id=58ee47a9&"
import script from "./AssembleiaList.vue?vue&type=script&lang=js&"
export * from "./AssembleiaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports